import { TextField, TextFieldProps } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from 'src/i18n';
import { AddressAutofillController } from "./useAddressAutofillController";

interface Props {
  value: string;
  onChange: (value: string) => void;
  addressAutofill?: AddressAutofillController;
  textFieldProps?: TextFieldProps;
}

const City = ({
  value,
  onChange,
  addressAutofill,
  textFieldProps
}: Props) => {
  const {t} = useTranslation();

  useEffect(() => {
    if (addressAutofill) {
      const newCityValue = addressAutofill.newValues.city;
      if (newCityValue !== value) { 
        onChange(newCityValue ?? '');
      }
    }
  }, [addressAutofill?.newValues.city, value, onChange]);

  return (
    <TextField 
      variant='standard'
      label={`${t('lang.city')}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      {...textFieldProps}
    />
  )
}
export default City;